import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import classNames from 'classnames'
import { t } from 'i18next'
import { ReactNode } from 'react'
import { FeedbackBox, FeedbackBoxIcon, FeedbackVariant } from '../../atoms/feedback-box'
import { IconFa } from '../../atoms/icon-fa'
import styles from './index.module.css'

interface Props {
  title?: string
  className?: string
  variant: FeedbackVariant
  messages: ReactNode[]
}

export function AccordionMessage(props: Props) {
  if (props.messages.length === 0) {
    return null
  }

  return props.messages.length === 1 ? (
    <FeedbackBox className={props.className} variant={props.variant} text={props.messages.at(0)} />
  ) : (
    <Disclosure>
      {({ open }) => (
        <div className={classNames(styles.container, styles[props.variant], props.className)}>
          <DisclosureButton className={styles.button}>
            <div className={styles.title}>
              <FeedbackBoxIcon type={props.variant} />
              {props.title ?? getTitle(props.variant, props.messages.length)}
            </div>
            <IconFa icon={['far', open ? 'chevron-up' : 'chevron-down']} />
          </DisclosureButton>
          <DisclosurePanel>
            <ul className={styles.panel}>
              {props.messages.map((message, index) => (
                <li className={styles.item} key={index}>
                  {message}
                </li>
              ))}
            </ul>
          </DisclosurePanel>
        </div>
      )}
    </Disclosure>
  )
}

function getTitle(type: FeedbackVariant, count: number): string {
  switch (type) {
    case 'error-light':
    case 'error-dark':
      return t('glow.accordionMessage.error', { count })
    case 'warning-light':
    case 'warning-dark':
      return t('glow.accordionMessage.warning', { count })
    case 'info-light':
    case 'info-dark':
      return t('glow.accordionMessage.info', { count })
    default:
      return t('glow.accordionMessage.general', { count })
  }
}
